module.exports = __webpack_public_path__ + "media/images/doctor_profiles/modal/pc/search_result_page/primary_organization-e476f22b2fe6b208547ed0df2bb8b147.png";